import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { IOrder } from "redux/reducers/models/order";

export interface IFoodOrder {
  id: number;
  kitchen_location_id: number;
  kitchen_location_title: string;
  line_items: IFoodOrderLineItems[];
  order: IOrder;
  sent_at: string;
  facility_id: number;
  status: string;
  table_id: number;
  name: string;
  number: number;
  notes: string;
  order_id: number;

  pickup_location_id: number;
  pickup_time: string;
  pickup_type: string;
  tee: string;
  table_short_title: string;
  table_title: string;
  user_full_name: string;
  user_id: number;
}

interface IFoodOrderLineItems {
  kitchen_chit_id: number;
  kitchen_meal_id: number;
  note: string;
  parent_id: number;
  preferred_title: string;
  product_title: string;
  order_line_item: IFoodOrderLineItem;
  children_line_items?: IFoodOrderLineItems[];
  order_line_item_id: number;
  quantity: number;
  status: string;
  subtitle: string;
  variant_title: string;
}
interface IFoodOrderLineItem {
  product_title: string;
  note: string;
}

interface IGetFoodOrders {
  id?: number;
  order_id?: number;
  status?: string;
  pickup_location_id?: number;
  pickup_location?: boolean;
  order?: boolean;
  line_items?: boolean;
  chits?: boolean;
  start_date?: string;
  end_date?: string;
}

export async function GetFoodOrders(params: IGetFoodOrders, useGlobalLoader: boolean) {
  return await APIGet<IFoodOrder[]>(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/order"),
    params,
    useGlobalLoader,
  );
}
interface IGetFoodOrderingCategory {
  id?: number; //don't pass for full list of categories on facility
}
interface IDeleteFoodOrderingCategory {
  id: number;
}
interface IPostFoodOrderingCategory {
  title: string;
}
interface IPutFoodOrderingCategory {
  id: number;
  title: string;
}

interface IGetFoodOrderingCategoryProduct {
  category_id: number;
}
interface IPostFoodOrderingCategoryProduct {
  category_id: number;
  product_ids: Array<number>;
}

export interface IPutFoodOrderStatus {
  id: number;
  status: string;
}

export async function PutFoodOrderStatus(params: IPutFoodOrderStatus, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/order"), params, useGlobalLoader);
}

//Food Ordering
//GET Food Ordering Settings
export async function GetFoodOrderingSettings(params: any, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/settings"), params, useGlobalLoader);
}

interface IPutFoodOrderingSettings {
  enabled: boolean;
  allow_off_course_orders: boolean;
  allow_on_course_orders: boolean;
  allow_on_course_deliveries: boolean;
  mark_orders_as_overtime: boolean;
  // overtime_minutes: string;
  print_orders_in_kitchen: boolean;
  print_orders: boolean;
  print_order_details_in_kitchen: boolean;
  send_confirmation_text: boolean;
  send_prep_time_text: boolean;
  send_ready_text: boolean;
  pay_at_counter: boolean;
  pay_online: boolean;
  pay_on_account: boolean;
  contact_name: string;
  contact_phone: string;
}

//PUT Food Ordering Settings
export async function PutFoodOrderingSettings(params: IPutFoodOrderingSettings, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/settings"), params, useGlobalLoader);
}

//POST Food Ordering Settings
export async function PostFoodOrderingSettings(params: IPutFoodOrderingSettings, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/settings"), params, useGlobalLoader);
}

interface IGetFoodOrderingCategory {
  id?: number; //don't pass for full list of categories on facility
}
interface IDeleteFoodOrderingCategory {
  id: number;
}
interface IPostFoodOrderingCategory {
  title: string;
}
interface IPutFoodOrderingCategory {
  id: number;
  title: string;
}

//GET Food Ordering Categories
export async function GetFoodOrderingCategories(
  params: IGetFoodOrderingCategory,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/category"),
    params,
    useGlobalLoader,
    token,
  );
}
//DELETE Food Ordering Categories
export async function DeleteFoodOrderingCategories(params: IDeleteFoodOrderingCategory, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/category"), params, useGlobalLoader);
}
//POST Food Ordering Categories
export async function PostFoodOrderingCategories(params: IPostFoodOrderingCategory, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/category"), params, useGlobalLoader);
}
//PUT Food Ordering Categories
export async function PutFoodOrderingCategories(params: IPutFoodOrderingCategory, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/category"), params, useGlobalLoader);
}

interface IGetFoodOrderingCategoryProduct {
  category_id: number;
}
interface IPostFoodOrderingCategoryProduct {
  category_id: number;
  product_ids: Array<number>;
}

//GET Food Ordering Category Products
export async function GetFoodOrderingCategoryProducts(
  params: IGetFoodOrderingCategoryProduct,
  useGlobalLoader: boolean,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/category/product"),
    params,
    useGlobalLoader,
  );
}

//POST Food Ordering Category Product
export async function PostFoodOrderingCategoryProduct(
  params: IPostFoodOrderingCategoryProduct,
  useGlobalLoader: boolean,
) {
  return await APIPost(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/category/product"),
    params,
    useGlobalLoader,
  );
}

//DELETE Food Ordering Category Product
export async function DeleteFoodOrderingCategoryProduct(
  params: IPostFoodOrderingCategoryProduct,
  useGlobalLoader: boolean,
) {
  return await APIDelete(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/category/product"),
    params,
    useGlobalLoader,
  );
}

interface IGetFoodOrderingPickupLocation {
  id?: number;
  type?: string;
}

//PICKUP LOCATIONS
//GET LOCATIONS
export async function GetFoodOrderingPickupLocation(
  params: IGetFoodOrderingPickupLocation,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/pickup-location"),
    params,
    useGlobalLoader,
    token,
  );
}

//POST LOCATIONS

interface IPostFoodOrderingPickupLocation {
  type: string; //on-course || off-course
  name: string;
  subtitle: string;
}

export async function PostFoodOrderingPickupLocation(
  params: IPostFoodOrderingPickupLocation,
  useGlobalLoader: boolean,
) {
  return await APIPost(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/pickup-location"),
    params,
    useGlobalLoader,
  );
}

interface IDeleteFoodOrderingPickupLocation {
  id: string;
}

export async function DeleteFoodOrderingPickupLocation(
  params: IDeleteFoodOrderingPickupLocation,
  useGlobalLoader: boolean,
) {
  return await APIDelete(
    APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/pickup-location"),
    params,
    useGlobalLoader,
  );
}

interface IGetFoodOrderingOrders {
  id?: number;
  order_id?: number;
  status?: string;
  pickup_location_id?: number;
  order?: boolean;
  line_items?: boolean;
}

export async function GetFoodOrderingOrders(params: IGetFoodOrderingOrders, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/food-ordering/order"), params, useGlobalLoader);
}
